import React from 'react';
import Product from '../../components/Product';
import { useIntl } from 'react-intl';

const Services = () => {

    const textTranslator = useIntl();

    const data = {
        id: 38,
        id_en: 319,
        title: textTranslator.formatMessage({ id: 'home.products.bloc.services.title' }),
        class_img: 'services'
    }
    return (
        <div>
            <Product data={data} />
        </div>
    );
};

export default Services;